export default class QuadroHorario {
    constructor() {
        this.id = null;
        this.descricao = null;
        this.codigoHorario = null;
        this.horasFechamento = null;
        this.validarFechamento = false;
        this.tipoEscala = null;
        this.diasDaSemana = [];
    }    
}